import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import router from './routes';
// @ts-ignore: side-effect CSS import has no type declarations
import '@mdi/font/css/materialdesignicons.min.css';
// @ts-ignore: side-effect CSS import has no type declarations
import './style.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
